import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import Image from '../../../helpers/Image/Image'
import { C002ImageItemProps } from './types'
import {
  StyledInstagramIcon,
  StyledImageContainer,
  StyledButton,
  StyledAuthorHandle,
  StyledViewProductsIcon,
  StyledTrolleyIcon,
  StyledViewProductsLabel,
  StyledCTALink
} from './C002.styles'

const C002ImageItem = ({
  item,
  index,
  setSelectedImage,
  imageItemOnClick,
  layout
}: C002ImageItemProps): React.ReactElement => {
  const theme = useContext(ThemeContext)
  const { channel } = theme
  const isSainsburys = channel === 'sainsburys'
  const numberOfProducts = item.productIds?.length
  const isStack = layout === 'stack'

  const ImageElement = (
    <StyledButton
      onClick={() => imageItemOnClick(item, index)}
      data-test={`c002-image-button-${index}`}
      layout={layout}
      as={isSainsburys ? 'div' : undefined}
      isSainsburys={isSainsburys}
    >
      <Image
        data-test={`c002-image-${index}`}
        src={item.url}
        alt={isSainsburys ? `Image by @${item?.author}` : `Image by @${item?.author} with ${numberOfProducts} products`}
        data-index={JSON.stringify(item.productIds)}
      />
      {isSainsburys && item?.buttonText && (
        <StyledCTALink data-test='c002-image-cta' kind='primary' full isCarousel={!isStack}>
          {item?.buttonText}
        </StyledCTALink>
      )}
      {!isSainsburys && (
        <StyledViewProductsIcon
          data-test={`c002-view-products-icon-${index}`}
          onClick={() => setSelectedImage({ ...item, index })}
          layout={layout}
        >
          <StyledTrolleyIcon data-test='trolley-icon' />
          {numberOfProducts}
          <StyledViewProductsLabel data-test='c002-view-products-label'>View Products</StyledViewProductsLabel>
        </StyledViewProductsIcon>
      )}
    </StyledButton>
  )
  return !isStack ? (
    <StyledImageContainer
      data-test={`c002-image-container-${index}`}
      key={`ugc-img-${index}`}
      role='listitem'
      layout={layout}
      isSainsburys={isSainsburys}
    >
      {ImageElement}
      {isSainsburys && (
        <StyledInstagramIcon
          data-test='instagram-icon'
          isSainsburys={isSainsburys}
          onClick={() => setSelectedImage({ ...item, index })}
        />
      )}
      {item?.author && !isSainsburys && (
        <StyledAuthorHandle data-test='c002-author-handle'>{`@${item && item.author}`}</StyledAuthorHandle>
      )}
    </StyledImageContainer>
  ) : (
    ImageElement
  )
}

export default C002ImageItem
